<div id="assign-sheets" *ngIf="formation">
    <div class="assign-header">
        <i id="back-report-button" class="material-icons back-btn" routerLink="../..">arrow_back</i>
        <span class="page-title" translate>Study Exercices</span>
        <span class="class-ref">for {{ occurrence.student.user.first_name}}'s {{ occurrence.start | date:'MMM dd' }} class</span>
    </div>



    <div class="assign-mainwrap">

        <div class="sheetslists-wrap">
     
            @if (type === 'offsite') {
                <button (click)="isCreating=true" class="btn-create">
                    <span translate>Create Exercice</span>
                </button>    
            }

            <app-exercice-assign *ngIf="formation"
                #exerciceAssign
                [typeExercice]="type"
                [formation]="formation"
                [validatedByStudent]="formation.student"
                [reportAddedSheet]="true" 
                (emitSheetToView)="showSheet($event)"
                (isSheetAdded)="reportSheetAdded($event)">
            </app-exercice-assign>
        </div>

        <div class="desktop-sheet-viewer">
            <app-exercice-view *ngIf="!isCreating" [exercice]="exercice"></app-exercice-view>

            @if (type === 'offsite') {
                <app-create-exercice-offsite *ngIf="isCreating" [language]="formation.language" (exerciceCreated)="reloadList($event)"></app-create-exercice-offsite>
            }
        </div>

    </div>

</div>